var _rect, _g, _path, _tspan, _path2, _path3, _path4, _g2, _g3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1363,
    height: 767,
    viewBox: "0 0 1363 767",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1363,
    height: 767,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 1363,
    height: 767,
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1362.54 0.5H0.5V766.82H1362.54V0.5Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NVIDIA's Growth Story 2000-2024",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 414.88,
    y: 163.794
  }, "NVIDIA&#39;s Growth Story 2000-2024"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M193.11 274.28V554.95",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M122.95 524.68H1263.48",
    stroke: "black",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M195.86 498.54L805.34 487.53L919.9 469.9C926.86 468.83 933.99 469.61 940.55 472.18L965.76 482.02C979.13 487.24 994.16 486.05 1006.54 478.78L1074.2 439.08C1083.92 433.38 1096.05 433.8 1105.35 440.15L1114.6 446.47C1131.13 457.76 1153.84 451.12 1161.7 432.72L1246.96 233.01",
    stroke: "#9A0033",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1246.97 233.01V239.01",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1246.97 259.08V505.89",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "12.04 20.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1246.97 515.93V521.93",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M861.75 477.9V483.9",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M861.75 499.39V516.44",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "9.3 15.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M861.75 524.18V530.18",
    stroke: "#24A0FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M330.69 180.73H1014.46",
    stroke: "#B3B3B3",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.6217cff36d764516155690bc46eb45a7.svg";
export { ForwardRef as ReactComponent };